<template><AgencyPlanningTool mode="capacity" /></template>
